export const FORM_STEP_DEFAULT_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: 8,
};

export const FORM_FIELD_CONTAINER_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'stretch',
  marginBottom: '8px',
};

export const FORM_FIELD_SELECTCARD_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  flexGrow: 1,
  flexShrink: 0,
  padding: 8,
  position: 'relative',
  minWidth: 0,
};

export const FORM_DEFAULT_ERROR_TEXT = 'Something went wrong';

export const FORM_DEFAULT_SELECT_INPUT_LABEL = 'Select field';
export const FORM_DEFAULT_SELECT_INPUT_PLACEHOLDER = 'Select option';
export const FORM_DEFAULT_SELECT_INPUT_OPTIONS = [
  { label: 'Option 1' },
  { label: 'Option 2' },
  { label: 'Option 3' },
];

export const FORM_DEFAULT_TEXT_INPUT_LABEL = 'Label';
export const FORM_DEFAULT_TEXT_INPUT_PLACEHOLDER = 'Placeholder';

export const FORM_DEFAULT_EMAIL_INPUT_PLACEHOLDER = 'email@email.com';

export const FORM_DEFAULT_CHECKBOX_LABEL = 'Label';
export const FORM_DEFAULT_CHECKBOX_OPTIONS = [{ label: 'Checkbox 1' }, { label: 'Checkbox 2' }];
export const FORM_DEFAULT_CHECKBOX_COLUMNS = 1;

export const FORM_DEFAULT_TEXTAREA_LABEL = 'Label';
export const FORM_DEFAULT_TEXTAREA_PLACEHOLDER = 'Placeholder';

export const FORM_DEFAULT_SINGLE_SELECT_CARD_LABEL = 'Single-Select Cards Label';
export const FORM_DEFAULT_MULTI_SELECT_CARD_LABEL = 'Multi-Select Cards Label';
export const FORM_DEFAULT_SELECT_CARD_COLUMNS = 2;
